import { useCallback, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { Reveal } from "./Reveal";

/** Real testimonials preserved from the existing homepage. Do not edit or add. */
const TESTIMONIALS = [
  {
    quote:
      "We had a awesome day of fishing with Robert!! Ended up with 45 white bass!! Thanks Robert!!!",
    name: "Phyllis Beaty Margheim",
  },
  {
    quote:
      "Robert is awesome! Had an amazing day! Caught white bass, catfish and black bass! Thank you!",
    name: "Cheryl Kohutek Maxie",
  },
  {
    quote:
      "My husband, Joe and Tom Moore went out today with Robert. Oh my gosh even with light rain and cold had a blast. Lots of fishing time, lots of tips, and advice on where to fish. Can't wait to go out fishing tomorrow and use lessons they learned! Worth every penny.",
    name: "Debbie Taylor Lindsey",
  },
];

export function Testimonials() {
  const [index, setIndex] = useState(0);
  const regionRef = useRef<HTMLDivElement>(null);
  const total = TESTIMONIALS.length;

  const go = useCallback((dir: 1 | -1) => setIndex((i) => (i + dir + total) % total), [total]);

  const current = TESTIMONIALS[index]!;

  return (
    <section className="bg-secondary py-24 sm:py-28 lg:py-32" aria-labelledby="testimonials-title">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-10">
        <Reveal className="text-center">
          <p className="eyebrow text-clay">Guest Stories</p>
          <h2
            id="testimonials-title"
            className="mt-4 font-display text-3xl leading-tight sm:text-4xl"
          >
            What Our Guests Say
          </h2>
        </Reveal>

        <div
          ref={regionRef}
          role="group"
          aria-roledescription="carousel"
          aria-label="Guest testimonials"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "ArrowRight") {
              e.preventDefault();
              go(1);
            }
            if (e.key === "ArrowLeft") {
              e.preventDefault();
              go(-1);
            }
          }}
          className="mt-14 rounded-sm border border-sand bg-surface p-8 shadow-[var(--shadow-soft)] sm:p-12"
        >
          <Quote className="size-8 text-sand" aria-hidden="true" />

          <div aria-live="polite" className="min-h-[11rem] sm:min-h-[9rem]">
            <blockquote key={index} className="mt-5 testimonial-fade">
              <p className="font-display text-xl leading-relaxed text-forest-deep sm:text-2xl">
                {current.quote}
              </p>
              <footer className="mt-6 text-sm font-semibold uppercase tracking-[0.14em] text-muted-foreground">
                <cite className="not-italic">{current.name}</cite>
              </footer>
            </blockquote>
          </div>

          <div className="mt-8 flex items-center justify-between border-t border-sand pt-6">
            <p className="text-xs font-semibold tracking-wide text-muted-foreground">
              {index + 1} / {total}
            </p>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => go(-1)}
                aria-label="Previous testimonial"
                className="inline-flex size-11 items-center justify-center rounded-sm border border-forest/25 text-forest transition-colors hover:bg-secondary"
              >
                <ChevronLeft className="size-5" aria-hidden="true" />
              </button>
              <button
                type="button"
                onClick={() => go(1)}
                aria-label="Next testimonial"
                className="inline-flex size-11 items-center justify-center rounded-sm border border-forest/25 text-forest transition-colors hover:bg-secondary"
              >
                <ChevronRight className="size-5" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
